<template>
  <div class="palletInformation table-responsive col-12">
    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      棧板資訊
    </li>
    <b-table
      :items="palletInformationItem"
      :fields="palletInformationFields"
      class="text-center palletInformation-table-detail palletInformation-table-detail-last"
    >
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "palletInformation",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      palletInformationFields: "palletInformation/get_palletInformationFields",
      palletInformationItem: "palletInformation/get_palletInformationItem",
    }),
  },
};
</script>

<style lang="scss">
.palletInformation-table-detail thead th {
  border-top: 1px solid;
  white-space: pre-line;
}
.palletInformation-table-detail th,
.palletInformation-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  background-color: #ffffff;
  vertical-align: middle !important;
}
.palletInformation-table-detail th:first-child,
.palletInformation-table-detail td:first-child {
  border-left: 1px solid;
}
.palletInformation-table-detail {
  margin-bottom: 0px;
}
.palletInformation-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
.palletInformation-table-detail-last tr:last-child td:nth-child(1) {
  background-color: transparent;
  border-color: transparent !important;
}
.palletInformation-table-detail-last tr:last-child td:nth-child(2) {
  background-color: transparent;
  border-color: transparent !important;
}
.palletInformation-table-detail-last tr:last-child td:nth-child(3) {
  background-color: transparent;
  border-color: transparent !important;
}
.palletInformation-table-detail-last tr:last-child td:nth-child(4) {
  background-color: transparent;
  border-color: transparent !important;
}
.palletInformation-table-detail-last tr:last-child td:nth-child(5) {
  background-color: transparent;
  border-color: transparent !important;
}
.palletInformation-table-detail-last tr:last-child td:nth-child(6) {
  background-color: transparent;
  border-top: 1px transparent solid !important;
  border-left: 1px transparent solid !important;
  border-bottom: 1px transparent solid !important;
  border-right: 2px #c10000 solid !important;
}
.palletInformation-table-detail-last tr:last-child td:nth-child(7) {
  border-bottom: 2px #c10000 solid !important;
  border-top: 2px #c10000 solid !important;
}
.palletInformation-table-detail-last tr:last-child td:nth-child(8) {
  border-bottom: 2px #c10000 solid !important;
  border-top: 2px #c10000 solid !important;
  border-right: 2px #c10000 solid !important;
}

</style>



// WEBPACK FOOTER //
// src/components/palletInformation.vue